<template>
  <div>
    <div class="main">
      <!-- Right -->
      <div class="main_r">
        <!-- search -->
        <div class="search">
          <div>
            <el-date-picker v-model="queryData.dayDate" type="date" value-format="yyyy-MM-dd" placeholder="日期" class="mr15"></el-date-picker>
            <el-button type="primary" @click="clickQuery">查询</el-button>
            <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
          </div>
        </div>
        <!-- search End -->

        <!-- 列表 -->
        <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" @sort-change="handleSortChange">
          <el-table-column prop="id" label="序号" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="dayDate" label="日期" sortable="custom"></el-table-column>
          <el-table-column prop="executeType" label="是否执行" sortable="custom">
            <template slot-scope="props">
              <span v-if="props.row.executeType == 1">是</span>
              <span v-if="props.row.executeType == 2">否</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" sortable="custom"></el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="mt20">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page_no"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="10"
            layout="prev, pager, next, sizes, jumper "
            :total="dataListnum">
          </el-pagination>
        </div>
        <!-- 分页 End -->
      </div>
      <!-- Right End -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {},
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      queryData: {
        wxUserId: '',
        dayDate: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 10,
      sortField: '',
      sortOrder: '',
      // 编辑
      dialogEdit: false,
      editData: {
        editId: '',
        userPassword: '',
        userName: '',
        userPhone: '',
        roleId: ''
      }
    }
  },
  mounted () {
  },
  watch:{
    "queryData.dayDate"(newVal){
      if(newVal == null){
        this.queryData.dayDate = ""
      }
      console.log(newVal);
    }
  },
  methods: {
    LoadData (row) {
      this.queryData.wxUserId = row.id
      this.queryData.dayDate = ''
      this.DietaryPlanExecuteList()
      this.DietaryPlanExecuteNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.DietaryPlanExecuteList()
      this.DietaryPlanExecuteNum()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.DietaryPlanExecuteList()
      this.DietaryPlanExecuteNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.DietaryPlanExecuteList()
      this.DietaryPlanExecuteNum()
    },
    clickQuery () {
      this.page_no = 1
      this.DietaryPlanExecuteList()
      this.DietaryPlanExecuteNum()
      console.log(this.queryData)
    },
    clickQueryReset () {
      this.queryData.dayDate = ''
      this.clickQuery()
    },
    DietaryPlanExecuteList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.wxUserId = that.queryData.wxUserId
      data.dayDate = that.queryData.dayDate
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DietaryPlanExecuteList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
          console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    DietaryPlanExecuteNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.wxUserId = that.queryData.wxUserId
      data.dayDate = that.queryData.dayDate
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DietaryPlanExecuteNum, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 300px;
    margin-right: 15px;
  }

  .el-select{
    margin-right: 15px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}
</style>
